import { render, staticRenderFns } from "./IconArrowRightShort.vue?vue&type=template&id=56782221"
import script from "./IconArrowRightShort.vue?vue&type=script&lang=js"
export * from "./IconArrowRightShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports